<template>
	<div class="center_main">
		<Carousel />
		<div class="wrapper">
			<div class="container">
				<!-- 热门游戏 -->
				<h1>热门游戏</h1>
				<p>网罗全网最热门游戏 <br />带来一站式全方位极致游戏体验</p>
				<ul class="hotGame">
					<li v-for="(item, index) in hotGame" :key="index" @mouseover="mouseOver(index)" @mouseout="mouseOver(index)">
						<router-link :to="item.to">
							<img :src="item.imgUrl" :alt="item.name" />
						</router-link>
					</li>
				</ul>
				<!-- 手机客户端下载 -->
				<!-- <h1 class="download">手机客户端下载</h1> -->
				<!-- <p>
					请使用 QRCode扫描器 扫描二维码进行下载,iOS 11 以上<br />
					的朋友可直接使用相机应用扫描，安装打开即可使用，感受 <br />
					流畅的移动投注体验。
				</p> -->
				<ul class="download-list">
					<li>
						<!-- <img :src="iosQRURL" class="QRCode" alt="QRCode" width="140" />
						<img src="@/static/img/home/download/android-icon.png" alt="icon" width="21" class="download-icon" />
						<img src="@/static/img/home/download/ios-icon.png" alt="icon" width="21" class="download-icon" /> -->
						<img src="@/static/img/home/download/mobile.png" alt="icon" height="100" @click="clickDownload" />
						<p>点此下载手机客户端</p>
					</li>
					<li>
						<img src="@/static/img/home/download/H52.png" alt="h5" height="78" />
						<p>
							输入网址打开H5<br />
							{{ H5Link }}
						</p>
					</li>
					<li>
						<img src="@/static/img/home/download/banner.png" alt="banner" width="479" />
					</li>
					<li>
						<p>推荐使用以下浏览器：</p>
						<img src="@/static/img/home/download/browser2.png" alt="browser" width="243" />
						<p class="dpi">
							官方推荐最佳分辨率：<br />
							1440px*900px 1680px*900px 1920px*1280px
						</p>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
// 轮播图
import Carousel from "@/components/mainPage/Carousel.vue";
import { SysKey } from "@/util/sysconfig";

export default {
	components: { Carousel },
	data() {
		return {
			iosQRURL: SysKey("ImgServerUrl").SysValue + SysKey("IosQrCodeUrl").SysValue,
			H5Link: window.location.origin,
			hotGame: [
				{
					name: "lottery",
					to: "/Racing?id=2023&index=2",
					imgUrl: require("@/static/img/home/hotGame/lotteryGame.png"),
					isHover: false,
				},
				{
					name: "peopleGame",
					to: "/peopleGame",
					imgUrl: require("@/static/img/home/hotGame/peopleGame.png"),
					isHover: false,
				},
				{
					name: "ptGame",
					to: "/ptGame",
					imgUrl: require("@/static/img/home/hotGame/ptGame.png"),
					isHover: false,
				},
				{
					name: "sportGame",
					to: "/sportGame",
					imgUrl: require("@/static/img/home/hotGame/sportGame.png"),
					isHover: false,
				},
				{
					name: "qpGame",
					to: "/qpGame",
					imgUrl: require("@/static/img/home/hotGame/qpGame.png"),
					isHover: false,
				},
			],
		};
	},
	methods: {
		mouseOver(index) {
			this.hotGame[index].isHover = !this.hotGame[index].isHover;
		},
		clickDownload() {
			window.open(window.systemData.AndroidDownUrl.SysValue, "_blank");
		},
	},
};
</script>

<style scoped lang="scss">
.wrapper {
	background-color: #edf0fa;
	padding-top: 80px;
	padding-bottom: 100px;
	.container {
		width: 100%;
		max-width: 1160px;
		margin: 0 auto;
		text-align: center;
		h1 {
			display: inline-block;
			font-size: 40px;
			text-align: center;
			color: transparent;
			background-image: linear-gradient(to top, #746eff 100%, #645fff 100%, #613bf9 100%);
			-webkit-background-clip: text;
			background-clip: text;
			position: relative;
			&::before,
			&::after {
				content: "";
				position: absolute;
				top: 50%;
				transform: translateX(-50%);
				background-size: contain;
				background-repeat: no-repeat;
				width: 472px;
				height: 18px;
			}
			&::before {
				left: -165%;
				background-image: url("~@/static/img/home/before.png");
			}
			&::after {
				left: 265%;
				background-image: url("~@/static/img/home/after.png");
			}
		}
		p {
			text-align: center;
			margin: 0 auto;
			font-size: 12px;
			color: #888888;
			font-family: "PingFangSC-Light";
		}
		ul.hotGame {
			display: flex;
			align-items: flex-end;
			flex-wrap: wrap;
			margin-top: 46px;
			li {
				width: 229px;
				transition: scale 0.3s;
				&:hover {
					filter: brightness(1.1);
					scale: 1.1;
				}
				img {
					width: 100%;
					max-width: 100%;
				}
			}
		}
		h1.download {
			margin-top: 108px;
			&::before {
				left: -95%;
			}
			&::after {
				left: 195%;
			}
		}
		ul.download-list {
			display: flex;
			align-items: center;
			text-align: left;
			margin-top: 35px;
			li:first-child {
				text-align: center;
				margin-right: 40px;
				.download-icon {
					margin: 21px 5px 0;
				}
				p {
					margin-top: 20px;
					font-size: 12px;
					color: #555;
					font-family: "PingFangSC-Regular";
				}
				.QRCode {
					display: block;
					box-shadow: 0px 4px 7px 0 rgba(0, 0, 0, 0.25);
					border-radius: 12px;
				}
				img {
					margin-top: 10px;
					cursor: pointer;
				}
			}
			li:nth-child(2) {
				text-align: center;
				margin-right: 50px;
				img {
					margin-top: 20px;
				}
				p {
					margin-top: 20px;
					color: #555;
					font-family: "PingFangSC-Regular";
				}
			}
			li:nth-child(3) {
				margin-right: 60px;
			}
			li:nth-child(4) {
				p {
					text-align: left;
					color: #555;
					font-family: "PingFangSC-Semibold";
					font-size: 16px;
					margin-bottom: 32px;
				}
				p.dpi {
					font-size: 12px;
					font-family: "PingFangSC-Regular";
					margin-top: 36px;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/mainPage/Home.vue